<mat-sidenav-container class="sidenav-container">
    <mat-sidenav-content>
        <mat-toolbar class="sidenav" style="background-color:#00abcf; color: white">
            <img src="assets/images/generico/logo.png" style="width: 50px; height: 50px;"><span>Expedientes - Municipalidad de {{ nombreMuni }}</span>
            <span class="col-md-2"></span>
            <div align="center">
                <div class="col-md-1" style="margin-right: 5px"></div>
                <span class="col-md-5" style="font-size: 15px"></span>
                <div class="col-md-1" style="margin-left: 15px; margin-right: 5px"></div>
                <span class="col-md-4" style="font-size: 15px"></span>
            </div>
            <div class="col-md-3"></div>
            <div class="col-md-2"></div>
            <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Mi Perfil"
                arial-label="Información del perfil">
                <mat-icon class="icon">person</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="inicio()">
                    <mat-icon class="iconcolor">work</mat-icon>
                    <span>Inicio</span>
                </button>
                <button (click)="perfil()" mat-menu-item>
                    <mat-icon class="iconcolor">face</mat-icon>
                    <span>Mi Perfil</span>
                </button>
                <button mat-menu-item (click)="logout()">
                    <mat-icon class="iconcolor">exit_to_app</mat-icon>
                    <span>Cerrar sesión</span>
                </button>
            </mat-menu>

            <button (click)="inicio()" mat-icon-button matTooltip="Servicios" arial-label="Volver al inicio">
                <mat-icon class="icon">home</mat-icon>
            </button>
        </mat-toolbar>

        <section>
            <div class="container">
                <div class="board">

                    <ng-template matStepLabel>Solicitudes</ng-template>
                    <div class="mat-elevation-z8">
                        <table mat-table [dataSource]="dataSource" matSort matSortStart="desc">

                            <ng-container matColumnDef="solicitud">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITUD </th>
                                <td mat-cell *matCellDef="let sol"> {{sol.solicitud}} </td>
                            </ng-container>

                            <ng-container matColumnDef="expediente">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> EXPEDIENTE </th>
                                <td mat-cell *matCellDef="let sol"> {{sol.expediente | uppercase}} </td>
                            </ng-container>

                            <ng-container matColumnDef="fecha_solicitud">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA SOLICITUD </th>
                                <td mat-cell *matCellDef="let sol"> {{sol.fecha_solicitud | date:'dd/MM/yyyy'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="departamento">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> DEPARTAMENTO </th>
                                <td mat-cell *matCellDef="let sol"> {{sol.departamento | uppercase}} </td>
                            </ng-container>

                            <ng-container matColumnDef="estado">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTADO </th>
                                <td mat-cell *matCellDef="let sol"> {{sol.descripcion | uppercase}} </td>
                            </ng-container>

                            <ng-container matColumnDef="detalle">
                                <th mat-header-cell *matHeaderCellDef> VER DETALLE </th>
                                <td mat-cell *matCellDef="let sol"> <button mat-icon-button
                                        (click)=get_solicitud(sol)><i class="material-icons">
                                            library_books
                                        </i></button> </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>

                        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
                    </div>

                </div>
            </div>
        </section>

    </mat-sidenav-content>
</mat-sidenav-container>
<footer>
    <div style="background-color: #262626; color: white">
        <p class="ftr-txt">{{footer}}</p>
        <a [href]="web" target="_blank"> {{web}}</a>
    </div>
</footer>
<ng-template #openModalExp>
    <div class="col-md-12">
        <div class="col-md-1"><img src="../../../assets/images/generico/logo.png" style="width: 190px; height: 90px"></div>
        <div class="col-md-11" align="center"><h1><strong>
       INFORMACION DEL EXPEDIENTE</strong></h1></div>

    </div>
    <div class="col-md-12"><img src="../../../assets/images/generico/logo.png" style="width: 100%; height: 5px"></div>
    <mat-dialog-content>
        <div class="form-group col-md-12" *ngIf='urb'>
            <div class="col-md-12" align="center">
                <h3><strong>DOM - Departamento de Urbanizacion</strong></h3>
                <hr />
            </div>
            <div class="col-md-12" align="center">
                <h4>Solicitud: <strong>{{seguim_exp.num_solicitud}}</strong></h4>
                <hr />
            </div>
        </div>
        <div class="form-group col-md-12" *ngIf='recep'>
            <div class="col-md-12" align="center">
                <h3><strong>DOM - Departamento de Recepci&oacute;n</strong></h3>
                <hr />
            </div>
            <div class="col-md-12" align="center">
                <h4><strong>Solicitud: </strong><strong>{{seguim_exp.num_solicitud}}</strong></h4>
                <hr />
            </div>
        </div>
        <div class="form-group col-md-12" *ngIf='edif'>
            <div class="col-md-12" align="center">
                <h3><strong>DOM - Departamento de Edificaci&oacute;n</strong></h3>
                <hr />
            </div>
            <div class="col-md-12" align="center">
                <h4><strong>{{seguim_exp.vivienda_altura}}</strong></h4>
                <hr />
            </div>
            <div class="col-md-12" align="center">
                <h4> N&uacute;mero de Expediente: <strong>{{seguim_exp.expediente}}</strong>
                </h4>
                <hr />
            </div>
        </div>
        <div class="form-group col-md-12">

            <mat-expansion-panel>
                <mat-expansion-panel-header style="background-color:#009abb; " *ngIf="urb || recep">
                    <mat-panel-title style="color: oldlace">
                        <h4>DATOS DE LA SOLICITUD</h4>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-expansion-panel-header style="background-color:#009abb; " *ngIf="edif">
                    <mat-panel-title style="color: oldlace">
                        <h4>DATOS DEL EXPEDIENTE</h4>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <mat-panel-description *ngIf="urb || recep">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Direccion</strong></div>
                        <div class="col-md-6">{{seguim_exp.direccion}}</div>
                    </div>
                </mat-panel-description>
                <mat-panel-description *ngIf="edif">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Direccion</strong></div>
                        <div class="col-md-6">{{seguim_exp.direccion_edif}}</div>
                    </div>
                </mat-panel-description>

                <mat-panel-description>
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Expediente</strong></div>
                        <div class="col-md-6">{{seguim_exp.expediente}}</div>
                    </div>
                </mat-panel-description>
                <mat-panel-description>
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Tipo</strong></div>
                        <div class="col-md-9">{{seguim_exp.tipo}}</div>
                    </div>
                </mat-panel-description>
                <mat-panel-description>
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Rol Propiedad</strong></div>
                        <div class="col-md-6">{{seguim_exp.rol_propiedad}}</div>
                    </div>
                </mat-panel-description>
                <mat-panel-description *ngIf="seguim_exp.fecha_ingreso">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Fecha de Ingreso</strong></div>
                        <div class="col-md-9">{{seguim_exp.fecha_ingreso | date:'dd/MM/yyyy'}}
                        </div>
                    </div>
                </mat-panel-description>
                <mat-panel-description *ngIf="urb || recep">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Estado</strong></div>
                        <div class="col-md-6">
                            <strong>{{seguim_exp.descripcion | uppercase}}</strong></div>
                    </div>
                </mat-panel-description>


            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header [style.background-color]="arquit">
                    <mat-panel-title [style.color]="colorarquit">
                        <h4>ARQUITECTO REVISOR</h4>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-panel-description *ngIf="arquitecto">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Nombre Arquitecto</strong></div>
                        <div class="col-md-6">{{seguim_exp.nombre_arquitecto | uppercase}}</div>
                    </div>
                </mat-panel-description>
                <mat-panel-description *ngIf="arquitecto && seguim_exp.email_arquitecto">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Email Arquitecto</strong></div>
                        <div class="col-md-6">{{seguim_exp.email_arquitecto}}</div>
                    </div>
                </mat-panel-description>

            </mat-expansion-panel>

            <mat-expansion-panel *ngIf="urb || edif">
                <mat-expansion-panel-header [style.background-color]="obser">
                    <mat-panel-title [style.color]="colorobserv">
                        <h4>ACTA DE OBSERVACIONES</h4>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-panel-description *ngIf="fechaacta && seguim_exp.fecha_acta">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Fecha Emision Acta</strong></div>
                        <div class="col-md-6">{{seguim_exp.fecha_acta  | date:'dd/MM/yyyy'}}
                        </div>
                    </div>
                </mat-panel-description>
                <mat-panel-description *ngIf="fechaacta && seguim_exp.plazo_maximo">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Plazo Maximo Contribuyente</strong></div>
                        <div class="col-md-6">{{seguim_exp.plazo_maximo | date:'dd/MM/yyyy'}}
                        </div>
                    </div>
                </mat-panel-description>
                <mat-panel-description *ngIf="fechaacta && seguim_exp.fecha_dom">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Fecha de Notificacion</strong></div>
                        <div class="col-md-6">{{seguim_exp.fecha_dom  | date:'dd/MM/yyyy'}}
                        </div>
                    </div>
                </mat-panel-description>

                <mat-action-row *ngIf="fechaacta && seguim_exp.fecha_acta" align="center">
                    <a mat-button style="background-color:#428bca;color:white" target="_blank"
                        [routerLink]="['/acta_expediente']">Visualizar Acta Informativa</a>
                </mat-action-row>

            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="recep">
                <mat-expansion-panel-header [style.background-color]="estadofecha">
                    <mat-panel-title [style.color]="fechacolor">
                        <h4>VISITA A TERRENO</h4>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <mat-panel-description *ngIf="fechavisita">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Fecha de Visita</strong></div>
                        <div class="col-md-6">
                            {{seguim_exp.fecha_visita_terreno  | date:'dd/MM/yyyy'}}</div>
                    </div>
                </mat-panel-description>

            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header [style.background-color]="estadocolor">
                    <mat-panel-title [style.color]="letracolor">
                        <h4>RESULTADO DE LA SOLICITUD: <span *ngIf="estatus">{{titulo}}</span><span
                                *ngIf="estatus_aprob">{{titulo}}</span><span *ngIf="rechazada">{{titulo}}</span></h4>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-panel-description *ngIf="(estatus || estatus_aprob) && seguim_exp.numero_aprobacion">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>N&uacute;mero</strong></div>
                        <div class="col-md-6">{{seguim_exp.numero_aprobacion}}</div>
                    </div>
                </mat-panel-description>
                <mat-panel-description *ngIf="(estatus || estatus_aprob) && seguim_exp.fecha_aprobacion">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Fecha Permiso</strong></div>
                        <div class="col-md-6">
                            {{seguim_exp.fecha_aprobacion  | date:'dd/MM/yyyy'}}</div>
                    </div>
                </mat-panel-description>
                <mat-panel-description *ngIf="rechazada && seguim_exp.numero_oficio">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>N&uacute;mero Oficio</strong></div>
                        <div class="col-md-6">{{seguim_exp.numero_oficio}}</div>
                    </div>
                </mat-panel-description>
                <mat-panel-description *ngIf="rechazada && seguim_exp.fecha_oficio">
                    <div class="col-md-12">
                        <div class="col-md-3"><strong>Fecha Oficio</strong></div>
                        <div class="col-md-6">{{seguim_exp.fecha_oficio  | date:'dd/MM/yyyy'}}
                        </div>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel>

        </div>
        <br />
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_antecedentes_edif" data-dismiss="modal"
            (click)="cleanData()">Cerrar</button>

    </mat-dialog-actions>
</ng-template>


<ng-template #openModal>
    <h2 mat-dialog-title>Informacion Expediente</h2>
    <mat-dialog-content>
        <div class="form-horizontal">
            <div class="form-group">
                <label class="col-md-4 control-label" for="rol">No se encontro la informacion solicitada</label>
            </div>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
            (click)="cleanData()">Cancelar</button>
    </mat-dialog-actions>
</ng-template>